import React, {useState} from "react";
import {HEADER_SIZE, LOCALSTORAGE_ITEMS, USER_TYPES} from "../util/Constants";
import Modal from "./Modal/Modal";
import {FormattedMessage} from 'react-intl';
import {useLocation} from "react-router-dom";
import backImg from "../assets/img/icon_back.svg";
import profileImg from "../assets/img/icon_profile.svg";
import closeGroupOrderImg from "../assets/img/icon_leave_group.svg";
import infoIcon from "../assets/img/icon_info_white.svg";

import iconClose from "../assets/img/icon_closed_grey.svg";
import openIcon from "../assets/img/icon_checkmark.svg";
import closedIcon from "../assets/img/icon_closed.svg";
import calendarIcon from "../assets/img/icon_calendar.svg";
import locationIconBlue from "../assets/img/icon_location_blue_2.svg";
import phoneIcon from "../assets/img/icon_phone.svg";

import {PATH} from "../routes/routes.js";
import CookiesBanner from "./Banner/CookiesBanner";
import ErrorModal from "./Modal/ErrorModal";
import WelcomeDemoModal from "./Modal/WelcomeDemoModal";
import * as StorageService from "../services/StorageService";
import {useNavigate} from "react-router";


function Header(props) {
    const location = useLocation();
    const navigateTo = useNavigate();
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const shopAddress = shopDetails ? (typeof shopDetails?.data?.address !== "undefined" ? shopDetails?.data?.address : null) : false;
    const shopPhone = shopDetails ? (typeof shopDetails?.data?.phone !== "undefined" ? shopDetails?.data?.phone : null) : false;
    const shopSchedule = shopDetails ? (typeof shopDetails.merchantConfig !== "undefined" ? shopDetails.merchantConfig?.weekOpenSchedule?.schedule : null) : false;
    let  headerBackground;
    let productBackground;
    let titleClassName;

    const [state, setState] = useState({
        shopInfoSlidingContainerVisible: false
    });


    const getShopClosingTime = (schedule) => {
        if (schedule) {
            const dayOfWeek = new Date().getDay() === 0 ? 6: new Date().getDay() -1; // because in Javascript Sunday is 0 and in the array from weekOpenSchedule Sunday is 6
            return schedule[dayOfWeek]?.openUntil;
        }
    }



    const goBack = () => {
        navigateTo(-1);
    }

    const getRedirectUrl = () => {
        if (props.isTakeAwayMenu) {
            return "?redirect="+PATH.TAKEAWAY;
        }else if (props.isDineInMenu) {
            return "?redirect="+PATH.ALL_PRODUCTS;
        }else if (props.isMainPage) {
            return "?redirect="+PATH.MAIN;
        }else{
            return "?redirect=back";
        }
    }

    const onProfileBtnClick = () => {
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) === USER_TYPES.VERIFIED.toString()) {
            navigateTo(PATH.PROFILE_HOME);
        }else{
            navigateTo({
                pathname: PATH.LOGIN,
                search: getRedirectUrl()
            });
        }
    }

    const onCloseGroupOrderBtnClick = () => {
        props.onCloseGroupOrderBtnClick();
    }

    if (props.hasBackgroundImg) {
        if (props.isProductPage) {
            headerBackground = {
                backgroundImage: 'url(' + props.imgUrl + ')'
            };
        }else{
            headerBackground = {
                backgroundImage: 'url(' + shopDetails?.welcome + ')'
            };
            titleClassName = "page-title"
        }

    }else{
        headerBackground = null;
        titleClassName = "page-title no-bg";
        titleClassName = "page-title no-bg";
    }


    const getHeaderSize = () => {
      if (props.headerSize === HEADER_SIZE.BIG) {
            return HEADER_SIZE.BIG;
        }else if (props.headerSize === HEADER_SIZE.MEDIUM) {
            return HEADER_SIZE.MEDIUM;
        }else if (props.headerSize === HEADER_SIZE.SMALL) {
            return HEADER_SIZE.SMALL;
        }else{
            return;
        }
    }

    const openShopInfoSlidingContainer = () => {
        setState({
            ...state,
            shopInfoSlidingContainerVisible: true
        })
    }

    const closeShopInfoSlidingContainer = () => {
        setState({
            ...state,
            shopInfoSlidingContainerVisible: false
        })
    }

    const toSchedulesPage = () => {
        navigateTo(PATH.SCHEDULES)
    }


    return (
        <>
            <WelcomeDemoModal/>
            <ErrorModal/>
            <CookiesBanner/>


            {props.hasModal &&
            <Modal/>
            }
        <header className={getHeaderSize()}>
            <div className={`top-banner ${props.isMainPage ? "main-page" : ""}`} style={headerBackground || productBackground}>


            {props.hasShopInfoIcon && <>
                  {state.shopInfoSlidingContainerVisible && <div onClick={() => closeShopInfoSlidingContainer()} className={"modal-overlay always-invisible"} >   </div>}
                  <div className={state.shopInfoSlidingContainerVisible ? "sliding-container visible" : "sliding-container"}>
                        <div className="sliding-inner">
                            <a className="btn-shop-info" onClick={() => closeShopInfoSlidingContainer()}><img alt="back" src={iconClose}/></a>
                            <div className="sliding-inner-content">

                                {shopSchedule && <div className="row schedule">
                                    <img src={calendarIcon} alt="calendar"/>&nbsp;
                                    <span className="label"><FormattedMessage id="ClosesAt"/>:</span>&nbsp;
                                    <span className="value">{getShopClosingTime(shopSchedule)}</span>
                                    <button className="btn btn-md btn-outlined schedules-btn" onClick={() => toSchedulesPage()}><FormattedMessage id="Schedules"/></button>
                                </div>}
                                {shopAddress && <div className="row location">
                                    <img src={locationIconBlue} alt="location"/>&nbsp;
                                    <span className="value">
                                        <a target="_blank"
                                           href={shopDetails.data.loc?.coordinates ? "https://www.google.com/maps/search/?api=1&query=" + shopDetails.data.loc?.coordinates[0][1] + "," + shopDetails.data.loc?.coordinates[0][0] : void (0)}>
                                            {shopAddress}
                                        </a>
                                    </span>
                                </div> }

                                {shopPhone && <div className="row phone">
                                    <img src={phoneIcon} alt="phone"/>&nbsp;
                                    <a href={"tel:" + shopDetails.data.phone} className="value">
                                        {shopPhone}
                                    </a>
                                </div>}
                            </div>
                        </div>
                  </div>
              </>}





              {props.hasBackBtn?
                <a className="btn-back" data-qa="header-back-btn" onClick={goBack}><img alt="back" src={backImg}/></a>
              :null}
              {props.hasProfileBtn?
                  <a className="btn-profile right-aligned" data-qa="header-profile-btn" onClick={onProfileBtnClick}><img alt="back" src={profileImg}/></a>
                  :null}
              {props.hasCloseGroupOrderBtn ?   <a className="btn-close-group-order right-aligned" data-qa="header-close-group-order-btn" onClick={onCloseGroupOrderBtnClick}><img alt="back" src={closeGroupOrderImg}/></a>
                  :null}

              {props.discount?
                  <span className="discount-ribbon">-{props.discount}%</span>
                  :null}
              {props.headerTitle?
                  <div className={titleClassName}>
                      <h1>{props.headerTitle}</h1>
                      {props.hasShopInfoIcon?
                          <a className="btn-shop-info" data-qa="header-shop-info-btn" onClick={openShopInfoSlidingContainer}><img alt="back" src={infoIcon}/></a>
                          :null}
                      {props.pickupAndDeliveryInfo ?
                          <div className="pickup-and-delivery-info">
                              {props.pickupAndDeliveryInfo.deliveryTime && <div className="row delivery">
                                  {props.hasDelivery && <div className="col">
                                      <p><FormattedMessage id="Delivery"/> {props.pickupAndDeliveryInfo.deliveryTime} min</p>
                                  </div>}

                                  <div className="col">
                                      <p className={props.pickupAndDeliveryInfo.open? "open":"closed"}>
                                          {props.pickupAndDeliveryInfo.open ?
                                         <> <FormattedMessage id="Open"/> <img alt="open icon" src={openIcon}/> </>
                                          : <><FormattedMessage id="Closed"/> <img alt="close icon" src={closedIcon}/> </>
                                          }
                                      </p>
                                  </div>
                              </div>}
                              {props.pickupAndDeliveryInfo.pickupTime && <div className="row pickup-row">
                                  <div className="col">
                                      <p><FormattedMessage id="Pickup"/> {props.pickupAndDeliveryInfo.pickupTime} min</p>
                                  </div>
                              </div>}

                          </div>
                          :null
                      }

                  </div>
                  :null
              }
              {/*{props.hasRatingBadge && <div className="rating-badge">*/}
              {/*    {starIcon}*/}
              {/*    &nbsp;*/}
              {/*    <span className="number">4.7</span>*/}
              {/*    &nbsp;*/}
              {/*    <span className="num-of-reviews">(500+)</span>*/}
              {/*</div>}*/}
          </div>

        </header>
        </>
    );

}

export default Header;
